export enum FORM_FIELDS {
    EMAIL = 'email',
    PASSWORD = 'password',
    PIN = 'pin',
}

export type FormFieldsType = {
    [FORM_FIELDS.EMAIL]: string;
    [FORM_FIELDS.PASSWORD]: string;
    [FORM_FIELDS.PIN]?: boolean;
}